import { Filters } from '@spo/logic';
import { VpEditIcon } from '@vtmn-play/icons/react';
import { VpButton, VpLink } from '@vtmn-play/react';
import { VtmnTag, VtmnTooltip } from '@vtmn/react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useUserConfig } from '../../../../hooks/useUserConfig';
import { FiltersBar, TabBar } from '../../../navigation';
import '../tableContainer.scss';

export const TableContainerHeader = ({
  totalSMs,
  selectedFilters,
  setSelectedFilters,
  tabViewIndex,
  setTabViewIndex,
  openPosterModal,
}: {
  totalSMs: number;
  selectedFilters: Filters;
  setSelectedFilters: (filters: Filters) => void;
  tabViewIndex: number;
  setTabViewIndex: (index: number) => void;
  openPosterModal: () => void;
}) => {
  const navigate = useNavigate();
  const { data: userConfig } = useUserConfig();
  const { t } = useTranslation();

  const isUserDateInThePast =
    userConfig &&
    userConfig.offerDate &&
    userConfig.offerDate <= format(new Date(), 'yyyy-MM-dd');

  const dateFormatted =
    userConfig &&
    userConfig.offerDate &&
    format(Date.parse(userConfig.offerDate), 'dd MMMM yyyy');

  const onModifyConfig = () => {
    navigate('/personal-offer/my-config?step=1');
  };

  return (
    <>
      <div
        id="table-title"
        data-testid="table-container-title"
        className="title"
      >
        {t('personal-offer.title')}
        <VtmnTooltip
          position="bottom-right"
          tooltip={isUserDateInThePast ? t('date_alert.message') : ''}
        >
          <VtmnTag
            data-testid="sm-tag_user_date"
            icon={`${isUserDateInThePast ? 'alert-line' : 'calendar-line'}`}
            variant={`${isUserDateInThePast ? 'alert' : 'decorative_cobalt'}`}
            className="vtmn-ml-5 vtmn-mr-2"
          >
            {dateFormatted}
          </VtmnTag>
        </VtmnTooltip>
        <VpLink
          data-testid="sm-link_user_date"
          onClick={onModifyConfig}
          size="medium"
        >
          <VpEditIcon />
        </VpLink>
        <VpButton
          size="small"
          shape="squared"
          variant="secondary"
          className="poster-cta"
          data-testid="poster_cta"
          aria-label="launch poster"
          onClick={openPosterModal}
        >
          {t('offer-poster.modal.generate')}
        </VpButton>
      </div>
      <TabBar
        total={totalSMs}
        setTabViewIndex={setTabViewIndex}
        tabViewIndex={tabViewIndex}
      />
      <FiltersBar
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        tabViewIndex={tabViewIndex}
      />
    </>
  );
};
